import { render, staticRenderFns } from "./SVGStepsPerspective.vue?vue&type=template&id=9f239568&scoped=true&"
import script from "./SVGStepsPerspective.vue?vue&type=script&lang=js&"
export * from "./SVGStepsPerspective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f239568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f239568')) {
      api.createRecord('9f239568', component.options)
    } else {
      api.reload('9f239568', component.options)
    }
    module.hot.accept("./SVGStepsPerspective.vue?vue&type=template&id=9f239568&scoped=true&", function () {
      api.rerender('9f239568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGStepsPerspective.vue"
export default component.exports